<template>
  <main v-if="!isShowSearch404PageViewed" class="catalog">
    <div class="container">
      <DefBreadCrumbs />
      <CatalogBanner />
      <CatalogSearch />
      <section class="catalog-controls">
        <CatalogFilterButton
          v-if="catalogSmartFilter && catalogSmartFilter.messages"
          @click="openFilter(true)"
        >
          {{ catalogSmartFilter.messages.title }}
        </CatalogFilterButton>
        <div class="catalog-controls__panels">
          <CatalogSort :result="catalogSort" @changeSort="changePageData" />
          <DefCardControl v-if="screenWidth >= 992 || screenWidth < 768" />
        </div>
      </section>
    </div>
    <section
      class="catalog-items pagination-scroll-js"
      :class="{ 'catalog-items_second': productListCardType === 2 }"
    >
      <TransitionGroup name="list">
        <div
          v-for="(item, key) in getItems"
          :key="((item.offer && item.offer.id) || item.id || key) + productListCardType"
          :class="{
            'product-banner-odd': odd,
            'product-banner': item.type === 'banner',
          }"
        >
          <CatalogProduct v-if="item.type !== 'banner'" :result="item" />
          <!-- even -->
          <CatalogLook v-else-if="item.size % 2 === 0 && even" :result="even" />
          <!-- odd -->
          <CatalogLook v-else-if="odd" :result="odd" />
        </div>
      </TransitionGroup>
    </section>
    <CatalogPagination :result="pagination" @change="handlerChangePage" @addMore="addMore" />
    <div class="container">
      <MainBannerDual :result="dualBanner" />
    </div>

    <CatalogFilter
      :result="catalogSmartFilter"
      :show="isOpenFilter"
      @close="openFilter(false)"
      @changeFilter="handlerChangeFilter"
      @resetFilter="changePageData"
      @remove="handlerRemove"
    />
    <CatalogFixedControls :result="catalogSmartFilter" />
    <div class="container">
      <ProductSliderRevised />
      <SeoText />
    </div>
  </main>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import CatalogBanner from '@components/Catalog/CatalogBanner.vue';
import DefBreadCrumbs from '@components/Def/DefBreadCrumbs/DefBreadCrumbs.vue';
import CatalogSearch from '@components/Catalog/CatalogSearch.vue';
import CatalogFilterButton from '@components/Catalog/CatalogFilterButton.vue';
import DefCardControl from '@components/Def/DefCardsContol/DefCardsControl.vue';
import CatalogSort from '@components/Catalog/CatalogSort/CatalogSort.vue';
import CatalogProduct from '@components/Catalog/CatalogProduct.vue';
import CatalogLook from '@components/Catalog/CatalogLook.vue';
import CatalogPagination from '@components/Catalog/CatalogPagination.vue';
import CatalogFilter from '@components/Catalog/CatalogFilter/CatalogFilter.vue';
import CatalogFixedControls from '@components/Catalog/CatalogFixedControls.vue';
import SeoText from '@components/Seo/SeoText.vue';
import ProductSliderRevised from '@components/Product/sliders/ProductSliderRevised.vue';
import useScreenWidth from '@use/useScreenWidth';
import Analytics from '@/utils/Analytics';
import MainBannerDual from '@components/Banners/MainBannerDual.vue';

export default {
  name: 'Catalog',
  components: {
    MainBannerDual,
    SeoText,
    CatalogFixedControls,
    CatalogFilter,
    CatalogPagination,
    CatalogLook,
    CatalogProduct,
    CatalogSort,
    DefCardControl,
    CatalogFilterButton,
    CatalogSearch,
    DefBreadCrumbs,
    CatalogBanner,
    ProductSliderRevised,
  },
  data() {
    return {
      pageNumberStart: 1,
      screenWidth: useScreenWidth(),
    };
  },
  computed: {
    ...mapState({
      items: ({ catalog }) => catalog?.data?.catalogSectionList?.items,
      viewed: ({ catalog }) => catalog?.data?.catalogSectionList?.viewed,
      isShowSearch404PageViewed: ({ catalog }) =>
        catalog?.data?.catalogSectionList?.isShowSearch404PageViewed,
      pagination: ({ catalog }) => catalog?.data?.catalogSectionList?.pagination,
      section: ({ catalog }) => catalog?.data?.catalogSectionList?.section,
      collection: ({ catalog }) => catalog?.data?.collection,
      productListCardType: ({ catalog }) => catalog.data.productListCardType,
      catalogSort: ({ catalog }) => catalog.data.catalogSort,
      catalogSmartFilter: ({ catalog }) => catalog.data.catalogSmartFilter,
      isOpenFilter: ({ catalog }) => catalog.data.openFilter,
      even: ({ catalog }) => catalog.data?.catalogSectionList?.banners?.even?.[0],
      odd: ({ catalog }) => catalog.data?.catalogSectionList?.banners?.odd?.[0],
      dualBanner: ({ catalog }) => catalog.data?.catalogSectionList?.banners?.dual,
    }),
    getItems() {
      try {
        const { pageSize, pagingKey } = this.pagination;
        const bannerPosition = 8;
        const newArr = [];

        this.items.forEach((el, i) => {
          if (i === bannerPosition || (i % (bannerPosition + pageSize) === 0 && i !== 0)) {
            const bannerCount = Math.floor(i / (bannerPosition + pageSize));
            let size = (+this.$route.query[pagingKey] || 1) + bannerCount;

            if (this.items.length > pageSize) {
              size = this.pageNumberStart + bannerCount;
            }

            // let size = this.items.length > pageSize ?
            //
            //     this.pageNumberStart + bannerCount :
            //
            //     (+this.$route.query[ pagingKey ] || 1) + bannerCount;

            if (size % 2 === 0 && this.even) {
              newArr.push({ type: 'banner', size });
            } else if (this.odd) {
              newArr.push({ type: 'banner', size });
            }
          }
          newArr.push(el);
        });

        return newArr;
      } catch (err) {
        console.error(err);
        return this.items;
      }
    },
  },
  methods: {
    ...mapMutations({
      openFilter: 'catalog/openFilter',
      deleteSelectedItem: 'catalog/deleteSelectedItem',
    }),
    ...mapActions({
      changePageData: 'catalog/changePageData',
      getMoreItems: 'catalog/getMoreItems',
      changeFilter: 'catalog/changeFilter',
    }),
    async handlerChangeFilter() {
      await this.changeFilter();
      this.openFilter(false);
    },
    saveStartPage() {
      const start = +this.$route.query[this.pagination?.pagingKey];
      if (start) {
        this.pageNumberStart = start;
      }
    },
    async handlerChangePage(e) {
      this.saveStartPage();
      await this.changePageData(e);
      Analytics.viewCatalog(this.items, this.section ?? this.collection);
    },
    async handlerRemove(item) {
      this.deleteSelectedItem(item);
      setTimeout(this.changeFilter, 4);
    },
    async addMore() {
      const response = await this.getMoreItems();
      const { items } = response.catalogSectionList;
      if (items) {
        Analytics.viewCatalog(items, this.section ?? this.collection);
      }
    },
  },
  created() {
    this.saveStartPage();
    Analytics.viewCatalog(this.items, this.section ?? this.collection);
  },
};
</script>

<style lang="scss" scoped>
.catalog {
  :deep(.def-card-control) {
    @include point-md {
      margin-right: 24px;
    }
  }
}
.catalog-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  margin: 16px 0;
  @include point-md {
    margin: 24px 0;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
  @include point-lg {
    display: flex;
    height: auto;
    background-color: transparent;
    justify-content: unset;
  }
  &__panels {
    display: flex;
    align-items: center;
    flex-grow: 1;
    justify-content: space-between;
  }
}
.catalog-items {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-column-gap: 8px;
  grid-row-gap: 24px;
  margin-bottom: 24px;
  @extend %container;
  @include point-md {
    grid-gap: 24px;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    margin-bottom: 32px;
  }
  @include point-lg {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    margin-bottom: 26px;
  }
  &_second {
    grid-template-columns: 1fr;
    @include point-md {
      grid-gap: 12px;
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    @include point-lg {
      grid-gap: 25px;
      grid-template-columns: repeat(5, minmax(0, 1fr));
    }
    .product-banner {
      @media (max-width: 767px) {
        grid-column: unset;
      }
    }
  }
}
.catalog-pagination {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 40px;
  @extend %container;
  @include point-md {
    margin-bottom: 60px;
  }
  @include point-lg {
    margin-bottom: 80px;
  }
}
.product-banner {
  grid-column: span 2;
}
.product-banner-odd {
  grid-row: span 2;
}

.list-enter-active {
  transition: all 0.7s ease-out;
  transition-delay: 0.01s;
}
.list-enter-from {
  transform: scale(0.6);
}
.list-enter-to {
  transform: scale(1);
}

.list-leave-from {
  opacity: 0;
  display: none;
}
.list-leave-to {
  opacity: 0;
  display: none;
}
.list-leave-active {
  display: none;
  transition: all 1.01s ease-out;
}
:global(.hide-pagination .def-bread-crumbs) {
  display: none;
}
:deep(.product-slider-revised .product-slider-title) {
  text-align: center;
}
</style>
